// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notif-item .settings-item:hover{background-color:#f0f0f0}.notif-item .dropdown-btn .dropdown{background-color:var(--color-secondary);display:none;position:absolute;right:0;top:20px;width:-moz-max-content;width:max-content}.notif-item .dropdown-btn .dropdown.last{top:-70px}.notif-item .dropdown-btn:hover .dropdown{display:block;z-index:2}.notif-item .notif-profile-img{height:48px;width:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
